/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Box: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_28797_23936)'>
      <path d='M15.6998 5H23.3998L17.6998 0.2C17.4998 0.1 17.1998 0 16.9998 0H13.7998L15.6998 5Z' fill='currentColor' />
      <path d='M16 7V14H8V7H0V23C0 23.6 0.4 24 1 24H23C23.6 24 24 23.6 24 23V7H16Z' fill='currentColor' />
      <path d='M8.29961 5L10.1996 0H6.99961C6.79961 0 6.49961 0.1 6.39961 0.2L0.599609 5H8.29961Z' fill='currentColor' />
    </g>
    <defs>
      <clipPath id='clip0_28797_23936'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
